export default "__VITE_ASSET__D7iJnnB9__"